import { useEffect, useRef } from 'react';
import { SpcResultsPos } from '../../../shared/types/spc.ts';
import { useResizeObserver } from '../../hooks/useResizeObserver.ts';
import { drawSigmaHistogram } from './drawSigmaHistogram.ts';
import { getHistogramData } from './getHistogramData.ts';


interface Props {
    className?: string,
    style?: React.CSSProperties,
    spcResult: SpcResultsPos,
}

export function SigmaHistogram({
    className,
    style,
    spcResult,
}: Props) {

    const containerRef = useRef<HTMLDivElement>(null);
    const dimensions = useResizeObserver(containerRef);


    //Draw default graph
    useEffect(() => {
        const data = getHistogramData(spcResult);
        drawSigmaHistogram(containerRef.current!, data);
    }, [spcResult, dimensions]);


    return (
        <div
            ref={containerRef}
            className={className}
            style={style}
        />
    )
}
